<template>
  <div class="rkpi">
    <div v-for="(k, i) in kpis" :key="i" class="rkpi__card">
      <div class="rkpi__top">
        <div class="rkpi__num" :style="{ color: k.accent ? '#b52118' : '#1a1814' }">{{ k.value }}</div>
        <div v-if="k.delta" class="rkpi__delta" :style="{ color: k.up ? '#2c6e49' : '#b52118' }">{{ k.delta }}</div>
      </div>
      <div class="rkpi__lbl">{{ k.label }}</div>
    </div>
  </div>
</template>

<script>
// Level 1 of the Reportes hierarchy: the four numbers that answer the tab's
// question, each against the previous period.
export default {
  props: {
    kpis: {
      type: Array,
      default: () => []
    }
  }
};
</script>

<style scoped>
.rkpi {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
  margin-bottom: 14px;
}
.rkpi__card {
  background: #fff;
  border: 1px solid #ece7de;
  border-radius: 14px;
  padding: 16px 18px;
  box-shadow: 0 8px 24px -16px rgba(40, 33, 22, 0.18);
}
.rkpi__top {
  display: flex;
  align-items: baseline;
  gap: 8px;
  min-width: 0;
}
.rkpi__num {
  font-size: 30px;
  font-weight: 700;
  line-height: 1;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.rkpi__delta {
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.rkpi__lbl {
  font-size: 12.5px;
  color: #756f64;
  margin-top: 7px;
  line-height: 1.3;
}

@media (max-width: 1199px) {
  .rkpi {
    grid-template-columns: 1fr 1fr;
  }
  .rkpi__num {
    font-size: 26px;
  }
}
</style>
